const accHD = document.getElementsByClassName('accordion-title');
const expandCollapseButtonContainer = document.getElementsByClassName('accordion-btn-container');

function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

docReady(() => {
  function toggleItem() {
    const itemClass = this.parentNode.className;
    const acContent = this.parentNode.querySelector('.accordion-content');
    this.parentNode.classList.toggle('close');
    this.parentNode.classList.toggle('open');
    if (itemClass.includes('close')) {
      this.setAttribute('aria-expanded', true);
      acContent.classList.remove('hide');
    } else {
      this.setAttribute('aria-expanded', false);
      acContent.classList.add('hide');
    }
  }

  function hashChange() {
    // Safely get and validate the hash
    const { hash: rawHash } = window.location;
    const safeHash = rawHash.replace(/[^a-zA-Z0-9-_]/g, '');
    if (safeHash) {
      const targetElement = document.querySelector(`#${safeHash}`);
      // eslint-disable-next-line no-unused-expressions
      targetElement
        ?.closest('.wp-block-twoyou-accordionitem.close')
        ?.querySelector('.accordion-title')
        ?.click();
    }
  }

  for (let i = 0; i < accHD.length; i += 1) {
    accHD[i].addEventListener('click', toggleItem, false);
  }

  function toggleMultipleItems() {
    const accordionParent = this.nextElementSibling;
    const accordionItems = accordionParent.children;
    const buttonContainerItems = this.children;
    const accordionContainerButton = buttonContainerItems[0];
    const accordionChevron = buttonContainerItems[1];
    const buttonContainerText = accordionContainerButton.innerText
      .toLowerCase()
      .includes('collapse');
    [...accordionItems].forEach(child => {
      const chevButton = child.querySelector('.wp-block-twoyou-accordiontitle');
      const acContent = child.querySelector('.accordion-content');
      if (buttonContainerText) {
        child.classList.remove('open');
        child.classList.add('close');
        acContent.classList.add('hide');
        chevButton.setAttribute('aria-expanded', false);
      } else {
        child.classList.remove('close');
        child.classList.add('open');
        chevButton.setAttribute('aria-expanded', true);
        acContent.classList.remove('hide');
      }
    });
    if (buttonContainerText) {
      accordionChevron.classList.replace(
        'accordion-btn-container-chevron-toggle',
        'accordion-btn-container-chevron-toggle-start',
      );
      accordionContainerButton.innerText = 'EXPAND ALL';
      accordionContainerButton.setAttribute('aria-pressed', false);
    } else {
      accordionChevron.classList.replace(
        'accordion-btn-container-chevron-toggle-start',
        'accordion-btn-container-chevron-toggle',
      );
      accordionContainerButton.innerText = 'COLLAPSE ALL';
      accordionContainerButton.setAttribute('aria-pressed', true);
    }
  }
  for (let i = 0; i < expandCollapseButtonContainer.length; i += 1) {
    expandCollapseButtonContainer[i].addEventListener('click', toggleMultipleItems, false);
  }
  window.addEventListener('hashchange', hashChange);
  hashChange(); // Check hash on page load

  const accordionButtons = document.getElementsByClassName('accordion-btn-text');
  [...accordionButtons].forEach(button => {
    button.setAttribute('aria-pressed', 'false');
  });

  const chevronButtons = document.getElementsByClassName('wp-block-twoyou-accordiontitle-chevron');
  [...chevronButtons].forEach(chev => {
    chev.setAttribute('aria-hidden', 'true');
  });
});
